"use strict";
if (!String.prototype.repeat) {
    String.prototype.repeat = function (length) {
        var result = "";
        for (var i = 0; i < length; i++) {
            result += this;
        }
        return result;
    };
}
//# sourceMappingURL=string-repeat.js.map